export default {
  init() {
    // JavaScript to be fired when a user is swell-eligible
  },
  finalize() {
    function validateEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }

    $(document).on('click', 'form.refer-form #swell-sign-up-submit', function(e) {
      e.preventDefault();
      var email = $(this).prev().val();
      var emailIsValid = validateEmail(email);
      if(emailIsValid) {
        $.ajax({
          type: 'POST',
          url: '/wp/wp-admin/admin-ajax.php',
          dataType: 'json',
          data: {
            action: 'add_update_swell_user',
            email_entered: email,
          },
          success: function(response) {
            alert(response.msg);
            if(response.err == false) {
              $(this).closest('.step-1').hide().next('.step-2').show();
            } else {
              if(response.err == 2) {
                window.location.pathname = '/my-account';
              }
            }
          },
          error: function() {
            alert('Unfortunately, something went wrong!');
          },
        });
      } else {
        alert('Please enter a valid email address!');
      }
    });

    $(document).on('click', '.refer-lightbox, .refer-lightbox .x', function(e) {
      e.preventDefault();
      $('.refer-lightbox').removeClass('open');
    });

    $(document).on('click', '.refer-lightbox .lightbox-inner', function(e) {
      e.stopPropagation();
    });

    // Check if user is soulmate and give them a special role if so
    // Doing this through AJAX because it gives time for swell to be updated with the order that was just processed.
    if($('body').hasClass('woocommerce-order-received')) {
      $(document).on('swell:setup', function() {
        var customerDetails = window.swellAPI.getCustomerDetails();
        var tier = customerDetails.vipTier.name;
        if(tier === 'Soulmate') {
          $.ajax({
            type: 'POST',
            url: '/wp/wp-admin/admin-ajax.php',
            dataType: 'json',
            data: {
              action: 'set_user_as_soulmate',
            },
            success: function() {
            },
            error: function() {
              console.log('An error occurred while trying to add the "Soulmate" role to the user.');
            },
          });
        }
      });
    }

    $(document).on('click', '.refer-lightbox, .refer-lightbox .x', function() {
      $('.refer-lightbox').removeClass('open');
    });

    $(document).on('click', '.link-copy-lightbox, .link-copy-lightbox .x', function() {
      $('.link-copy-lightbox').removeClass('open');
    });

    $(document).on('click', '.swell-birthday-lightbox, .swell-birthday-lightbox .x', function() {
      $('.swell-birthday-lightbox').removeClass('open');
    });

    $(document).on('click', '.link-copy-lightbox .lightbox-inner, .refer-lightbox .lightbox-inner, .swell-birthday-lightbox .lightbox-inner', function(e) {
      e.stopPropagation();
    });

    $(document).on('click', '.link-copy-lightbox .copy-button', function(e) {
      e.preventDefault();
      var copyText = $(this).prev('.link-to-copy');
      copyText.select();
      copyText[0].setSelectionRange(0, 99999); /*For mobile devices*/
      document.execCommand('copy');
      $(this).addClass('copied');
      setTimeout(function() {
        $('.link-copy-lightbox').removeClass('open');
        $('.link-copy-lightbox .copy-button').removeClass('copied');
      }, 2000);
    });

    $(document).on('click', '.show-buck-options, .global-cart .actions .back', function(e) {
      e.stopPropagation();
      $('.show-buck-options').toggleClass('open').parent().next().next('.choose-bucks-inner').slideToggle(200);
    });

    $(document).on('click', '.boss-welcome .btn[href*="cart"]', function(e) {
      e.stopPropagation();
      $('.show-buck-options').addClass('open').parent().next().next('.choose-bucks-inner').slideDown(200);
    });

    $(document).on('swell:setup', function() {

      // On email referral submission
      var referredCustomersInput = $('#referred-customers-input');
      var sendEmailsBtn = $('#referred-customers-send-btn');

      if($('.refer-lightbox').length) {
        $('.refer-lightbox').addClass('open');
      }

      $(sendEmailsBtn).click(function(e) {
        e.preventDefault();
        var emails = referredCustomersInput.val().split(',');
        var onSuccess = function() {
          referredCustomersInput.val('');
          sendEmailsBtn.addClass('sent');
          setTimeout(function() {
            sendEmailsBtn.removeClass('sent');
          }, 4000);
        }
        var onError = function(err) {
          alert('ERROR: ' + err);
        }
        window.swellAPI.sendReferralEmails(emails,onSuccess, onError);
      });

      var customerDetails = window.swellAPI.getCustomerDetails();

      $('#rewards-history .check-balance').click(function(e) {
        e.preventDefault();
        alert(customerDetails.pointsBalance + ' Beauty Bucks available!');
      });

      $(document).on('click', '.share-list .li a', function(e) {
        e.preventDefault();
        if($('input.link-to-copy').val() == '') {
          $('input.link-to-copy').val(customerDetails.referralLink);
        }
        $('.link-copy-lightbox').addClass('open');
      });

      if($('input.link-to-copy').length) {
        $('input.link-to-copy').val(customerDetails.referralLink);
      }

      var fillAndSubmitCouponCodeForm = function(couponCode) {
        var optionEl = $('.choose-bucks .option-wrap input[type="radio"]:checked');
        var chosenOption = optionEl.length ? optionEl : null;
        var pointsUsed = chosenOption.next('label').attr('data-val');
        var discountApplied = '$' + (pointsUsed / 10) + '.00';

        $.ajax({
          type: 'POST',
          url: '/wp/wp-admin/admin-ajax.php',
          dataType: 'json',
          data: {
            action: 'bbe_add_coupon_action',
            couponcode: couponCode,
          },
          success: function(response) {
            if (response.message === 'valid') {
              if (response.refresh_cart === 1) {
                $('body').trigger('update_checkout');
                $('body').trigger('added_to_cart');
              }

              $('.bucks-message').html('Redeemed <span class="used-points">' + pointsUsed + '</span> points for a <span class="discount-amt">' + discountApplied + '</span> discount on this order!<span class="cart-discount__remove remove-reward"></span>').show();
            } else {
              $('.bucks-message').html('Uh oh... something went wrong! Redemption code might not be valid. \nMessage: ' + response.message).show();
            }
            $('.choose-bucks').hide();
          },
          error: function(response) {
            if (response.message === 'valid') {
              if (response.refresh_cart === 1) {
                $('body').trigger('update_checkout');
                $('body').trigger('added_to_cart');
              }

              $('.bucks-message').html('Redeemed <span class="used-points">' + pointsUsed + '</span> points for a <span class="discount-amt">' + discountApplied + '</span> discount on this order!<span class="cart-discount__remove remove-reward"></span>').show();
            } else {
              $('.bucks-message').html('Uh oh... something went wrong! Redemption code might not be valid. \nMessage: ' + response.message).show();
            }
          },
        });
      };

      var onSuccess = function(redemption) {
        fillAndSubmitCouponCodeForm(redemption.couponCode);
      };

      var onError = function(err) {
          alert(err.message);
          console.log(err);
      };

      $(document).on('click', '.choose-bucks .actions .redeem', function(e) {
        e.preventDefault();

        if(!$('.choose-bucks .option-wrap .option:not(.not-available)').length) {
          alert('You need to earn more Beauty Bucks before you can redeem! Keep shopping!');
          return false;
        }

        var optionEl = $('.choose-bucks .option-wrap input[type="radio"]:checked');
        var chosenOption = optionEl.length ? optionEl.val() : null;

        window.swellAPI.makeRedemption(
          { redemptionOptionId: chosenOption, delayPointDeduction: true },
          onSuccess,
          onError
        );
      });
      var tier = customerDetails.vipTier.name;

      if(tier != '') {
        if($('.boss-earn-more').length) {
          $('.boss-earn-more .item.' + tier).addClass('current-status');
        }
        $('.user-tier .tier').text(tier);
      } else {
        $('.user-tier').hide().prev('.user-bucks').addClass('no-tier');
      }

      if($('.boss-ways-to-earn').length) {
        var activeCampaigns = window.swellAPI.getActiveCampaigns();
        activeCampaigns.forEach(function(campaign){
          if(campaign.customerCompleted === true) {
            $('.boss-ways-to-earn .item[data-campaign-id="' + campaign.id + '"]').addClass('completed');
          }
        });
      }

      window.addEventListener('klaviyoForms', function(e) {
        if (e.detail.type == 'submit') {
          window.swellAPI.captureNewsletterSignup(e.detail.metaData.$email);
        }
      });

      // Referrals list population
      if(customerDetails.referrals.length > 0) {
        $('.referral-list-wrap').show();
        customerDetails.referrals.forEach(function(item) {
          if(item.email === customerDetails.email) {
            return;
          }
          var signedUp = item.signedUpAt ? 'Signed up!' : 'Pending';
          $('#custom-history-container').append(
            '<div>' +
              '<span>' + item.email + '</span>' +
              '<span>' + signedUp + '</span>' +
            '</div>'
          );
        });
      }

      if(customerDetails.actionHistoryItems.length > 0) {
        $('.reward-list-wrap').show();
        customerDetails.actionHistoryItems.forEach(function(item) {
          if(item.points === 0 || item.status !== 'Approved') {
            return;
          }
          $('#custom-rewards-history-container').append(
            '<div>' +
              '<span>' + item.action + '</span>' +
              '<span>' + item.points + '</span>' +
            '</div>'
          );
        });
      }

      if(customerDetails.pointsBalance !== parseInt($('header.banner .user-bucks .count').text())) {
        var usedPoints = parseInt($('.global-cart .used-points').text());
        var pointsBalance = usedPoints > 0 ? parseInt(customerDetails.pointsBalance) - usedPoints : customerDetails.pointsBalance;
        $('header.banner .user-bucks .count').text(pointsBalance);
      }

      // Birthday popup
      $(document).on('click', '.submit-birthday', function(e) {
        e.preventDefault();
        var day = $('.swell-birthday-lightbox select.day').val();
        var month = $('.swell-birthday-lightbox select.month').val();
        var year = $('.swell-birthday-lightbox select.year').val();
        $('.swell-birthday-lightbox .submit-birthday').addClass('loading');
        $.ajax({
          type: 'POST',
          url: '/wp/wp-admin/admin-ajax.php',
          dataType: 'json',
          data: {
            action: 'swell_add_birthday',
            day: day,
            month: month,
            year: year,
          },
          success: function() {
            $('.swell-birthday-lightbox .submit-birthday').addClass('complete').removeClass('loading');
            setTimeout(function() {
              $('.swell-birthday-lightbox').removeClass('open');
              $('.swell-birthday-lightbox .submit-birthday').removeClass('complete');
            }, 2000);
          },
          error: function() {
            alert('Something went wrong!');
          },
        });
      });
    }); // End swell:setup

    var availableTiers = [];
    $('.boss-earn-more .item').each(function() {
      const tier = $(this).find('.item-header > h3').text();
      if(tier !== 'Admirer') {
        availableTiers.push(tier);
      }
    });

    if($('h2.rotate-tier-name').length) {
      var avTierInd = 0;
      setInterval(function() {
        if(avTierInd > 2) { avTierInd = 0 }
        $('h2.rotate-tier-name .tier-name').text(availableTiers[avTierInd]);
        avTierInd++;
      }, 2000);
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/swell.js